
const SuccessfulModal = ({ email, onClose }) => {
    const handleGoBack = () => {
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-pale-white opacity-4 flex items-center justify-center z-50">
            <div className="w-auto sm:w-4/6 md:w-1/2 xl:max-w-lg border border-gray bg-white rounded-md shadow-md">
                <div className="p-4">
                    <h2 className="text-sm md:text-xl font-medium mb-3">Successful!</h2>
                    <p className="mb-0.5 text-success-email text-xs md:text-sm font-normal">
                        An invite has been sent to
                    </p>
                    <p className="mb-0.5 text-success-email text-xs md:text-sm font-normal">
                        {email}.
                    </p>
                </div>

                <div className="flex justify-end bg-th-bg py-3 rounded-tr-none rounded-tl-none rounded-br-md rounded-bl-md">
                    <button
                        className="px-4 py-2 me-4 bg-enabled-btn text-white text-xs md:text-sm font-medium rounded-md"
                        onClick={handleGoBack}
                    >
                        Go back to Teams
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SuccessfulModal;

